import React from 'react';
import routes from 'src/bootstrap/initializeRoutes';
import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ErrorBoundary from 'src/ErrorBoundary';
import { ClientContext } from 'src/graphqlhooks';
import store from 'src/store';
import GraphQLFactory from 'src/graphQLFactory';
import SiteSettings from 'src/siteSetting';
import { identity, memoizeWith } from 'ramda';

const Main = (props: any) => {
  const servicingClient = new GraphQLFactory('SERV', SiteSettings.graphqlServEndpoint()).create();
  const applicationClient = new GraphQLFactory('APPG', SiteSettings.graphqlAppEndpoint()).create();
  const graphQLClients = { servicingClient, applicationClient }
  const renderNull = () => <span>null route</span>;

  return (
    <ErrorBoundary>
      <ClearBrowserCacheBoundary auto fallback="Loading" duration={60000}>
        <Provider store={store}>
          <ClientContext.Provider value={graphQLClients}>
            <Router>
              <Switch>
                <Route exact path="/null" render={renderNull} />
                <Route render={routes} />
              </Switch>
            </Router>
          </ClientContext.Provider>
        </Provider>
      </ClearBrowserCacheBoundary>
    </ErrorBoundary>
  );
}
const routesMemoized = memoizeWith(identity, Main);
export default routesMemoized;
